// extracted by mini-css-extract-plugin
export default {"copyButton":"styles__copyButton-ScK48","copyColumn":"styles__copyColumn-NWjtt","subSection":"styles__subSection-eDB1k","presentation":"styles__presentation-xlxpr"};